/** Settings (company) API — Faz 1.4 createApi factory. */
import {createApi} from './_factory'
import type {SettingNs} from '@shared/types'

const api = createApi('company')

export const SettingsApi = {
  getCompanyInfo: (data: SettingNs.CompanyInfoRequest) =>
    api.post<SettingNs.CompanyInfoRequest, SettingNs.CompanyInfo>('get-company-info', data),
  updateCompanyProperties: (data: SettingNs.UpdateCompanyInfoRequest) =>
    api.post<SettingNs.UpdateCompanyInfoRequest, SettingNs.CompanyInfo>('update-properties', data),
}
